import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Classes, Durations, Events } from './constants';
import { fixMobileHover, getCookiesAllowed, initGTM, isDisclaimerAccepted, isTouchScreen, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, sortAnimations, wait } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- Touch Screen ----------

if(isTouchScreen()) {
	$Elements.html.addClass('touchscreen');
}

// ---------- Fix VH ----------

$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
$Elements.window.trigger('resize');

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, async() => {

	// ---------- Fix Mobile Hover ----------

	fixMobileHover();

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.PageWrapper.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.PageWrapper.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target[0]);
		}
		else {
			smoothScrollTo(0, Durations.animations.s, 0)
		}
	});

	$Elements.PageWrapper.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	// ---------- GLightbox ----------

	$('[target="lightbox"]').each(function() {

		if($(this).attr('data-size') === 'full') {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}
	});

	$('[target^="lightbox-gallery"]').each(function() {

		if($(this).attr('data-size') === 'full') {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}
	});

	// ---------- Cookies ----------

	initGTM();

	if(!getCookiesAllowed()) {

		const cookies = document.querySelector('#cookies-allowed');

		if(cookies) {

			cookies.classList.remove(Classes.hidden);
			await wait(100);
			cookies.classList.add(Classes.show);

			$(cookies).on('click', '[data-bs-dismiss="alert"]', function() {
				setCookiesAllowed(this.dataset.allowed);
			});
		}
	}

	// ---------- Disclaimer ----------

	if(!isDisclaimerAccepted()) {

		const disclaimer = document.querySelector('#disclaimer');

		if(disclaimer) {

			disclaimer.classList.remove(Classes.hidden);
			$Elements.body.addClass(Classes.disclaimer);

			$(disclaimer).on('close.bs.alert', function() {
				setDisclaimerAccepted();
				$Elements.body.removeClass(Classes.disclaimer);
			});
		}
	}

});
